import { createFileRoute } from "@tanstack/react-router";
import DangerZoneSettingsPage from "@/features/user-settings/pages/danger-zone";
import { getSEOMetadata, createHeadMeta } from "@/common/lib/seo/seo-helpers";

export const Route = createFileRoute("/settings/danger-zone")({
  component: DangerZoneSettingsPage,
  head: ({ match }) =>
    createHeadMeta(
      match.context.localization.i18n,
      getSEOMetadata(
        match.context.localization.i18n,
        "seo.settingsDangerZone.title",
        "seo.settingsDangerZone.description",
      ),
      { noIndex: true },
    ),
});
